
export const calculateInstallmentAmount = (totalAmount: number, installments: number) => {
  if (totalAmount === 0) return 0;
  return Math.ceil(totalAmount / installments);
};
